
import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";
import "./i18n"; // Inicializar i18n
import { initGA } from "./lib/analytics";
import { logger } from "./lib/logger";
// Inicializar Sentry (antes de cualquier lógica de app)
initSentry();
const mainLogger = logger.withContext('Main');
// Inicializar Google Analytics
initGA();
// Registrar Service Worker para PWA y Push Notifications
if ('serviceWorker' in navigator) {
  // Cuando un SW nuevo toma control (vía clients.claim()), recargar la página
  // para que la pestaña deje de ejecutar JS cacheado de la versión vieja.
  let isReloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (isReloading) return;
    isReloading = true;
    mainLogger.info('Service Worker nuevo activo, recargando página');
    window.location.reload();
  });

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });
      mainLogger.info('Service Worker registrado correctamente', {
        scope: registration.scope,
      });
      // Manejar actualizaciones del SW
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              mainLogger.info('Nueva versión del Service Worker disponible, esperando activación');
            }
          });
        }
      });
      // Verificar si hay actualizaciones cada 60 segundos
      setInterval(() => {
        registration.update().catch((err) => {
          mainLogger.warn('Error comprobando update del SW', err);
        });
      }, 60 * 1000);
      // Comprobar updates también cuando el usuario vuelve a la pestaña
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update().catch(() => {});
        }
      });
    } catch (error) {
      mainLogger.error('Error registrando Service Worker:', error);
    }
  });
  // Detectar cuando el SW se activa
  navigator.serviceWorker.ready.then((registration) => {
    mainLogger.info('Service Worker listo y activo');
  });
}
// Detectar instalación de PWA
window.addEventListener('beforeinstallprompt', (e) => {
  // Guardar el evento para usarlo después
  mainLogger.info('PWA instalable detectada');
  // Guardar el evento globalmente para usarlo desde la UI
  (window as any).deferredPrompt = e;
});
window.addEventListener('appinstalled', () => {
  mainLogger.info('PWA instalada exitosamente');
  // Limpiar el prompt guardado
  (window as any).deferredPrompt = null;
  // Trackear instalación (si analytics está configurado)
  if (window.gtag) {
    window.gtag('event', 'pwa_installed', { category: 'PWA' });
  }
});
// Auto-reload on stale chunk errors after deploy
window.addEventListener('error', (e) => {
  const msg = e.message || '';
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module')
  ) {
    const reloadKey = 'chunk-reload';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      window.location.reload();
    }
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || String(e.reason) || '';
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module')
  ) {
    const reloadKey = 'chunk-reload';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      window.location.reload();
    }
  }
});
// Clear reload flag on successful load
sessionStorage.removeItem('chunk-reload');
createRoot(document.getElementById("root")!).render(<App />);